export function trimString(value: string): string {
  const trimmedString = value.trim();

  return trimmedString.slice(-1) === ','
    ? trimmedString.slice(0, -1)
    : trimmedString;
}



// WEBPACK FOOTER //
// ./src/components/TaskManagement/utils/trimString.ts